import { render, staticRenderFns } from "./MainLike.vue?vue&type=template&id=6178cf7c&scoped=true&"
import script from "./MainLike.vue?vue&type=script&lang=js&"
export * from "./MainLike.vue?vue&type=script&lang=js&"
import style0 from "./MainLike.vue?vue&type=style&index=0&id=6178cf7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178cf7c",
  null
  
)

export default component.exports